.da{padding:0.5rem;}